//-----------------------------------------------------------------------------
//----- Copyright deersoft 2015 - 2019 www.deersoft.de
//-----------------------------------------------------------------------------

export const kDefaultLanguage = "en";

const kSupportedLanguages = new Set([
  "en",
  "de",
  "es",
  "fr",
  "it",
  "ru",
  "cz",
  "tr",
  "zh",
  "ja",
  "nl",
  "pt",
]);

export function hasBrowserWindow() {
  return typeof window !== "undefined";
}

export function hasBrowserDocument() {
  return typeof document !== "undefined";
}

export function normalizeLanguageCode(rawLanguage?: string) {
  if (!rawLanguage || typeof rawLanguage !== "string") {
    return kDefaultLanguage;
  }

  const normalized = rawLanguage.toLowerCase().trim();
  if (normalized.length === 0) {
    return kDefaultLanguage;
  }

  const primaryLanguage = normalized.split(/[-_]/)[0];
  if (primaryLanguage === "cs") {
    return "cz";
  }

  if (kSupportedLanguages.has(primaryLanguage)) {
    return primaryLanguage;
  }

  return kDefaultLanguage;
}

export function getPreferredLanguage() {
  if (hasBrowserWindow()) {
    const storedLanguage = window.localStorage?.getItem("language");
    if (storedLanguage) {
      return normalizeLanguageCode(storedLanguage);
    }
  }

  if (
    typeof navigator !== "undefined" &&
    typeof navigator.language === "string"
  ) {
    return normalizeLanguageCode(navigator.language);
  }

  return kDefaultLanguage;
}
